//
// Suggestion
// A view controller that is used by the AI Assist Widget to render a suggestion
//

define(function(require) {
  var ViewController = require('web-agent-framework/ViewController');
  var SuggestionDropdownViewController = require('web-agent-viewControllers/SuggestionDropdownViewController');

  var SuggestionViewController = ViewController.extend({
    ControllerName: 'SuggestionViewController',

    LPViewMap: {
      suggestionItems: '.lp_ai_assist_suggestion_items',
      botName: '.lp_ai_assist_suggestion_bot_name',
      reason: '.lp_ai_assist_reason_text',
      time: '.lp_ai_assist_reason_time',
      score: '.lp_ai_assist_suggestion_score',
      intent: '.lp_ai_assist_suggestion_intent',
      actionButton: '.lp_ai_assist_action_button',
      positiveAction: '.lp_ai_assist_feedback_item_yes',
      negativeAction: '.lp_ai_assist_feedback_item_no',
      feedback: '.lp_ai_assist_feedback',
      sendAction: '.lp_ai_assist_submit',
      input: '.lp_ai_assist_input',
      dropdownArrow: '.lp_ai_assist_dropdown_arrow',
      dropdownItems: '.lp_ai_assist_dropdown_items'
    },

    LPClassesMap: {
      feedbackIsActive: 'lp_ai_assist_feedback_active',
      visible: 'lp_ai_assist_visible'
    },

    initialize: function(data) {
      // Set up references controllers
      this.suggestionsController = lpTag.WebAgent.suggestionsController;

      // Set UI state
      this.feedbackIsOpen = false;
      this.dropdownIsOpen = false;
      this.feedbackText = '';

      this.dropdownItems = [
        {
          textValue: 'ai_assist_bad_intent',
          enumValue: 'badIntent'
        },
        { textValue: 'ai_assist_bad_bot', enumValue: 'badBot' }
      ];

      // Set context variables
      this.visitorId = data.visitorId;
      this.agentId = data.agentId;
      this.suggestion = data.suggestion;
      this.chat = data.chat;

      this.refreshEmptySuggestion = data.refreshEmptySuggestion;

      // Generate content
      var botName = this.translateObj('ai_assist_bot_can_assist', [
        {
          isTranslate: false,
          key: data.suggestion.botName
        }
      ]);
      var reason = '"' + data.chat.text + '"';
      var serverTimestamp = this.formatTime(data.chat.time);
      var score = this.translateScore(data.suggestion.mappedScore);
      var intent = data.suggestion.intent;
      var actionName = this.translate('ai_assist_transfer');

      // inject content to DOM
      this.getFirstElement(this.LPViewMap.botName).textContent = botName;
      this.getFirstElement(this.LPViewMap.reason).textContent = reason;
      this.getFirstElement(this.LPViewMap.time).textContent = serverTimestamp;
      this.getFirstElement(this.LPViewMap.score).textContent = score;
      this.getFirstElement(this.LPViewMap.intent).textContent = intent;
      this.getFirstElement(
        this.LPViewMap.actionButton
      ).textContent = actionName;

      this.createDropdownItems();
    },

    events: function() {
      // Bind button clicks
      this.bindViewEvent({
        selector: this.LPViewMap.actionButton,
        DOMEvent: 'click',
        callback: this.handleActionClick.bind(this)
      });
      this.bindViewEvent({
        selector: this.LPViewMap.positiveAction,
        DOMEvent: 'click',
        callback: this.handlePositiveClick.bind(this)
      });
      this.bindViewEvent({
        selector: this.LPViewMap.negativeAction,
        DOMEvent: 'click',
        callback: this.handleNegativeClick.bind(this)
      });
      this.bindViewEvent({
        selector: this.LPViewMap.sendAction,
        DOMEvent: 'click',
        callback: this.handleSendClick.bind(this)
      });
      this.bindViewEvent({
        selector: this.LPViewMap.input,
        DOMEvent: 'change',
        callback: this.handleInputChange.bind(this)
      });
      this.bindViewEvent({
        selector: this.LPViewMap.dropdownArrow,
        DOMEvent: 'click',
        callback: this.handleDropdownClick.bind(this)
      });
    },

    render: function() {}
  });

  /**
   * Translate the score from a number between 0 and 1, to a string of text
   */
  SuggestionViewController.prototype.translateScore = function(score) {
    this.suggestionsController.parseScore(score);
    return (
      this.translate(this.suggestionsController.parseScore(score)) +
      ' (' +
      Math.floor(score * 100) +
      '%)'
    );
  };

  /**
   * Create all the feedback dropdown items
   */
  SuggestionViewController.prototype.createDropdownItems = function() {
    this.dropdownItems.forEach(this.createDropdownItem.bind(this));
  };

  /**
   * Create a feedback dropdown item
   */
  SuggestionViewController.prototype.createDropdownItem = function(reason) {
    var dropdownViewController = new SuggestionDropdownViewController({
      reason: this.translate(reason.textValue),
      setInputText: this.setInputText.bind(this),
      hideDropdown: this.hideDropdown.bind(this),
      className: 'lp_ai_assist_suggestion_dropdown_view',
      templateFile: 'LP_ai_assist_widget_suggestion_dropdown.html'
    });

    this.addViewController({
      viewController: dropdownViewController,
      target: this.getFirstElement(this.LPViewMap.dropdownItems)
    });
  };

  /**
   * Hide the invisible suggestion and refresh the UI.
   */
  SuggestionViewController.prototype.hideSuggestionUI = function() {
    // TODO: find out what happens if I don't call this hide function
    this.hide();
    // TODO: Do I need to deal with garbage collection by destroying this suggestion?
    this.refreshUI();
  };

  /**
   * Hide the suggestion
   */
  SuggestionViewController.prototype.hideSuggestion = function() {
    this.removeClass(this.view, this.LPClassesMap.visible);
    setTimeout(this.hideSuggestionUI.bind(this), 300);
  };

  /**
   * Handle the suggestion action click
   */
  SuggestionViewController.prototype.handleActionClick = function() {
    this.suggestionsController.sendPositiveFeedback({
      value: 'suggestionUsed',
      visitorId: this.visitorId,
      chat: this.chat,
      suggestion: this.suggestion
    });
    this.hideSuggestion();

    var skillId =
      this.suggestion.skillIds &&
      this.suggestion.skillIds.length &&
      this.suggestion.skillIds[0];

    // TODO: instead of calling transferChat, we could addManagerParticipant
    // - for this we might need to lookup the bots that have those skills,
    // and find the userId of the first bot that has that skill and then use
    // that userId to add them to the conversation

    if (skillId) {
      this.transferChatToSkill({
        chatId: this.chat.conversationId,
        text: this.chat.text,
        skillId: skillId
      });
    }
  };

  /**
   * Transfer the chat to a bot via a skillId
   */
  SuggestionViewController.prototype.transferChatToSkill = function(data) {
    return lpTag.WebAgent.amsConversationController.transferChat({
      chatId: data.chatId,
      text: data.text,
      skillId: data.skillId,
      success: this.suggestionsController.handleActionSuccess,
      error: this.suggestionsController.handleActionError
    });
  };

  /**
   * Handle the vote up click
   */
  SuggestionViewController.prototype.handlePositiveClick = function() {
    this.suggestionsController.sendPositiveFeedback({
      visitorId: this.visitorId,
      chat: this.chat,
      suggestion: this.suggestion
    });
    this.hideSuggestion();
  };

  /**
   * Handle the vote down click
   */
  SuggestionViewController.prototype.handleNegativeClick = function() {
    if (!this.feedbackIsOpen) {
      this.suggestionsController.sendNegativeFeedback({
        visitorId: this.visitorId,
        chat: this.chat,
        suggestion: this.suggestion
      });
      this.openFeedbackDrawer();
    } else {
      this.closeFeedbackDrawer();
    }
  };

  /**
   * Handle the send button click
   */
  SuggestionViewController.prototype.handleSendClick = function() {
    this.suggestionsController.sendNegativeFeedback({
      text: this.feedbackText,
      reason: this.suggestionsController.getFeedbackEnum(
        this.dropdownItems,
        this.feedbackText
      ),
      visitorId: this.visitorId,
      chat: this.chat,
      suggestion: this.suggestion
    });
    this.hideSuggestion();
  };

  /**
   * close the feedback drawer and refresh the UI
   */
  SuggestionViewController.prototype.refreshUI = function() {
    this.closeFeedbackDrawer();
    // hide this item, then refresh the UI after a short while
    setTimeout(this.refreshEmptySuggestion, 500);
  };

  /**
   * Open the feedback drawer
   */
  SuggestionViewController.prototype.openFeedbackDrawer = function() {
    this.addClass(this.view, this.LPClassesMap.feedbackIsActive);
    this.feedbackIsOpen = true;
  };

  /**
   * Close the feedback drawer
   */
  SuggestionViewController.prototype.closeFeedbackDrawer = function() {
    this.removeClass(this.view, this.LPClassesMap.feedbackIsActive);
    this.feedbackIsOpen = false;
  };

  /**
   * Handle the feedback input change event
   */
  SuggestionViewController.prototype.handleInputChange = function(event) {
    this.feedbackText = event.target.value;
  };

  /**
   * Set the the feedback input text
   */
  SuggestionViewController.prototype.setInputText = function(text) {
    this.feedbackText = text;
    this.getFirstElement(this.LPViewMap.input).value = text;
  };

  /**
   * Handle the feedback dropdown arrow click
   */
  SuggestionViewController.prototype.handleDropdownClick = function() {
    if (this.dropdownIsOpen) {
      this.hideDropdown();
    } else {
      this.showDropdown();
    }
  };

  /**
   * Show the feedback dropdown container
   */
  SuggestionViewController.prototype.showDropdown = function() {
    this.dropdownIsOpen = true;
    this.addClass(this.LPViewMap.dropdownItems, this.LPClassesMap.visible);
  };

  /**
   * Hide the feedback dropdown container
   */
  SuggestionViewController.prototype.hideDropdown = function() {
    this.dropdownIsOpen = false;
    this.removeClass(this.LPViewMap.dropdownItems, this.LPClassesMap.visible);
  };

  return SuggestionViewController;
});
